var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1832_26)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1832_26)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1832_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4688 -9.41669H-24.4687C-28.3089 -9.41669 -31.4219 -6.09613 -31.4219 -2.00002V33C-31.4219 37.0961 -28.3089 40.4166 -24.4687 40.4166H56.4688C60.3089 40.4166 63.4219 37.0961 63.4219 33V-2.00002C63.4219 -6.09613 60.3089 -9.41669 56.4688 -9.41669Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.178 4.1452C23.1692 4.1452 22.3516 5.01706 22.3516 6.09257C22.3516 6.27479 22.375 6.45117 22.4189 6.61845C23.4517 6.16384 24.63 5.8975 25.9931 5.87457C25.8916 4.90168 25.1177 4.1452 24.178 4.1452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 6.23041C24.6766 6.25247 23.5363 6.51037 22.5381 6.95101C22.8358 7.59601 23.4583 8.03987 24.178 8.03987C25.1433 8.03987 25.9336 7.24156 26 6.23041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9752 6.82965V6.12463C19.9568 6.12463 18.3206 7.86917 18.3206 10.0212V10.1529C18.621 9.7325 18.9379 9.332 19.2752 8.95678C20.0523 8.0923 20.9372 7.36215 21.9752 6.82965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3206 10.7514C18.6916 10.1998 19.0873 9.68018 19.5161 9.20317C20.2302 8.40875 21.0365 7.7325 21.9752 7.2265V19.4383C21.9752 21.5903 20.339 23.3348 18.3206 23.3348V10.7514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2916 11.7642C16.6416 10.6856 15.5064 9.97113 14.2147 9.97113V18.0312C14.5506 17.3463 14.8774 16.6427 15.2062 15.9347L15.2069 15.9332C15.2484 15.8438 15.2899 15.7544 15.3316 15.6648C15.9481 14.3384 16.5768 13.0032 17.2916 11.7642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2147 18.7888C14.6579 17.9176 15.0775 17.014 15.4967 16.1112C15.5413 16.0151 15.5859 15.919 15.6305 15.823C16.2212 14.5522 16.8162 13.2895 17.4806 12.1171C17.7293 12.6434 17.8693 13.2381 17.8693 13.8676V26.8548C15.8509 26.8548 14.2147 25.1103 14.2147 22.9583V18.7888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7635 18.9259V13.4023C11.745 13.4023 10.1088 15.1468 10.1088 17.2988V23.745C10.6564 23.3273 11.1527 22.8367 11.6108 22.2893C12.4262 21.3152 13.1194 20.1637 13.7635 18.9259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1088 24.1778C10.7551 23.7146 11.3329 23.1558 11.8597 22.5263C12.5718 21.6756 13.1917 20.6945 13.7635 19.6466V21.7011C13.7635 23.8531 12.1272 25.5976 10.1088 25.5976V24.1778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47066 24.1827C9.59006 23.7977 9.65467 23.386 9.65467 22.9583V20.0224C7.63625 20.0224 6 21.767 6 23.919V25.2428C7.35389 25.1625 8.49047 24.7832 9.47066 24.1827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 25.5993C7.252 25.5275 8.32775 25.2092 9.26888 24.7028C8.66859 25.979 7.43024 26.8548 6 26.8548V25.5993Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1832_26",
    x: -31.9219,
    y: -9.91669,
    width: 95.8438,
    height: 55.8333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.101961 0 0 0 0 0.137255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1832_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1832_26",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1832_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1832_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 23,
    fill: "white",
    transform: "translate(6 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrass);
export default __webpack_public_path__ + "static/media/GRASS.1adc66a4bfa3ed806a9bc368badf601a.svg";
export { ForwardRef as ReactComponent };